type IconProps = {
  className?: string;
  size?: number;
};

export function IconLock({ className = "", size = 24 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill="currentColor"
        d="M22 11.003H10v-1.25c0-3.451 2.685-6.25 5.998-6.25 2.184-.001 4.195 1.233 5.252 3.223.322.604 1.052.821 1.632.486.58-.335.789-1.096.467-1.7-2.247-4.226-7.36-5.756-11.418-3.416C9.258 3.638 7.6 6.57 7.6 9.753v1.78c-2.184.993-3.597 3.237-3.6 5.72v7.498c.004 3.45 2.688 6.245 6 6.249h12c3.312-.004 5.996-2.8 6-6.25v-7.498c-.004-3.45-2.688-6.245-6-6.25ZM17.2 22.25c0 .69-.537 1.25-1.2 1.25-.663 0-1.2-.56-1.2-1.25v-2.5c0-.69.537-1.25 1.2-1.25.663 0 1.2.56 1.2 1.25v2.5Z"
      />
      <path
        fill="currentColor"
        d="M10 11.003h12v-1.25c0-3.451-2.685-6.25-5.998-6.25-2.184-.001-4.195 1.233-5.252 3.223-.322.604-1.052.821-1.632.486-.58-.335-.789-1.096-.467-1.7 2.247-4.226 7.36-5.756 11.418-3.416C22.742 3.638 24.4 6.57 24.4 9.753v1.78c2.184.993 3.597 3.237 3.6 5.72v7.498c-.004 3.45-2.688 6.245-6 6.249H10c-3.312-.004-5.996-2.8-6-6.25v-7.498c.004-3.45 2.688-6.245 6-6.25Zm4.8 11.248c0 .69.537 1.25 1.2 1.25.663 0 1.2-.56 1.2-1.25v-2.5c0-.69-.537-1.25-1.2-1.25-.663 0-1.2.56-1.2 1.25v2.5Z"
      />
    </svg>
  );
}
